<template>
  <div>
    <div class="formWrapper niche-wr filled">
      <b-row>
        <b-col cols="12">
          <div class="form-header floatCss">
            <b-row>
              <b-col cols="12">
                <div class="form-header-inner d-flex justify-content-between">
                  <div class="d-flex">
                    <div class="dForm-top-logo">
                      <img :src="logoSrc">
                    </div>
                    <div class="dForm-companyDetails">
                      <div class="dForm-cmBlock">
                        <h2>
                          <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                        </h2>
                      </div>
                      <div class="dForm-cmBlock2">
                        <p>(Co. Reg. No. 200401183W)</p>
                        <p>(GST Group Reg. No. M90364395L)</p>
                      </div>
                    </div>
                  </div>
                  <div class="dForm-top-right d-flex">
                    <h5 class="text-block font-small-12">
                      NV-SG-CSD-FS03 REV: 2
                    </h5>
                    <h5>File No: {{ formData.fileNo || '-' }}</h5>
                    <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="pp-section-tittle">
                  <h2>Sales order - niche 骨灰灵位认购同意书</h2>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row class="payment-plan-section">
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="pp-section-tittle">
                <h3>Earliest Interment Date: <strong>Immediate</strong> <span>Need Type:
                  <strong>{{ formData.needType || 'Pre-need' }}</strong></span></h3>
                <p>I hereby agree to purchase a Licence for the niche specified hereunder in the columbarium known as
                  "Nirvana" for the consideration stipulated herein</p>
                <h4>本人同意购买下列位于"富贵山庄"骨灰殿内的骨灰灵位使用权，售价注明如下</h4>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="ssfp-form-wrapper">
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="pp-section-tittle2">
                <h2>PARTICULARS of purchaser 购买者资料</h2>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col cols="12">
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  Full Name as in NRIC / Passport <br>身份证 / 护照上的全名
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.customerName || '-' }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  NRIC/ Passport No <br>身份证/ 护照号码
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.customerNric || '-' }}
                </div>
              </div>
            </b-col>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-2">
                  Nationality <br>国籍
                </div>
                <div class="ssfp-text-field-input-2">
                  {{ formData.customerNationality || '-' }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  Birth Date <br>出生日期
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.customerDob || '-' }}
                </div>
              </div>
            </b-col>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-2">
                  Sex <br>性別
                </div>
                <div class="ssfp-text-field-input-3">
                  <div
                    class="ssfp-check-box"
                    :class="{ active: formData.customerSex === 'Male' }"
                  >
                    Male 男
                  </div>
                  <div
                    class="ssfp-check-box"
                    :class="{ active: formData.customerSex === 'Female' }"
                  >
                    Female 女
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col cols="12">
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  Permanent Address <br>永久地址
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.permanentAddress }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col cols="12">
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  Correspondence Address <br>通讯地址
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.correspondenceAddress }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  E-mail Address <br>电邮
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.customerEmail || '-' }}
                </div>
              </div>
            </b-col>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-2">
                  Contact No. <br>联络号码
                </div>
                <div class="ssfp-text-field-input-2">
                  {{ formData.customerContact || '-' }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-section-tittle2">
                <h2>PARTICULARS of intended user 受提名使用者资料</h2>
              </div>
            </b-col>
          </b-row>
          <div
            v-for="(item, index) in formData.intendedUsers"
            :key="index"
          >
            <b-row
              :key="'row1-' + index"
              class="ssfp-single-row"
            >
              <b-col
                cols="7"
                md="7"
                lg="7"
              >
                <div class="ssfp-text-field-row floatCss">
                  <div class="ssfp-text-field-single ssfp-field-width-1">
                    Name <br>姓名
                  </div>
                  <div class="ssfp-text-field-input-1">
                    {{ item.name || '-' }}
                  </div>
                </div>
              </b-col>
              <b-col
                cols="5"
                md="5"
                lg="5"
              >
                <div class="ssfp-text-field-row floatCss">
                  <div class="ssfp-text-field-single ssfp-field-width-2">
                    NRIC No. <br>身份证号码
                  </div>
                  <div class="ssfp-text-field-input-2">
                    {{ item.nric || '-' }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row
              :key="'row2-' + index"
              class="ssfp-single-row"
              :class="{ 'custom-gap-10': index !== formData.intendedUsers.length - 1 }"
            >
              <b-col
                cols="7"
                md="7"
                lg="7"
              >
                <div class="ssfp-text-field-row floatCss">
                  <div class="ssfp-text-field-single ssfp-field-width-1">
                    Birth Date <br>出生日期
                  </div>
                  <div class="ssfp-text-field-input-1">
                    {{ item.dob ? dateFormat(item.dob) : '-' }}
                  </div>
                </div>
              </b-col>
              <b-col
                cols="5"
                md="5"
                lg="5"
              >
                <div class="ssfp-text-field-row floatCss">
                  <div class="ssfp-text-field-single ssfp-field-width-2">
                    Relationship <br>关系
                  </div>
                  <div class="ssfp-text-field-input-2">
                    {{ item.relation || '-' }}
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-section-tittle2">
                <h2>PARTICULARS of the niche to which this license relates 骨灰灵位资料</h2>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="ssfp-pl-block floatCss">
                <h3>{{ formData.nicheNo }} • {{ formData.lotType }} Lot 双位 <span>(This Sales Order serves as a Tax Invoice if GST is
                  charged)</span></h3>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-pl-single-row">
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div class="ssfp-pl-block floatCss">
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Niche Price 骨灰灵位价格
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    $ {{ numberFormat(formData.productPrice) }}
                  </div>
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Maintenance Fees 维修费
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    $ {{ numberFormat(formData.maintenanceFee) }}
                  </div>
                </div>
                <div
                  v-if="totalDiscount()"
                  class="ssfp-pl-list floatCss"
                >
                  <div class="ssfp-pl-left-label floatCss">
                    <div class="d-flex justify-content-between w-100">
                      <span>Rebate 折扣</span>
                      <span class="mr-50">–</span>
                    </div>
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    $ {{ numberFormat(totalDiscount()) }}
                  </div>
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    GST 消费税 {{ formData.gstPercentage || 9 }}%
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    $ {{ numberFormat(formData.gstAmount || 0) }}
                  </div>
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    <strong>Total 总额</strong>
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    <strong>$ {{ numberFormat(formData.totalAmount || 0) }}</strong>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div class="ssfp-pl-block-right nsf-right floatCss">
                <h3>NOTES</h3>
                <p>This purchase shall be subject to the attached Terms And Conditions, the contents of which I have
                  read and fully understood.</p>
              </div>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-section-tittle2">
                <h2>mode of certificate collection 证书领收方式</h2>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col cols="12">
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-cck">
                  Certificate to be collected by <br>接收证书人士或方式
                </div>
                <div class="ssfp-check-container">
                  <div class="pp-check-group">
                    <div
                      class="pp-check-single"
                      :class="{ active: formData.certificateCollectionOption === 'representative' }"
                    >
                      Authorised Representative 授权代表
                    </div>
                    <div
                      class="pp-check-single"
                      :class="{ active: formData.certificateCollectionOption === 'purchaser' }"
                    >
                      Purchaser 购买者
                    </div>
                    <div
                      class="pp-check-single"
                      :class="{ active: formData.certificateCollectionOption === 'mail' }"
                    >
                      Mail 邮寄
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="formData.certificateCollectionOption === 'representative'"
            class="ssfp-single-row"
          >
            <b-col cols="12">
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-small">
                  Name<br>代表全名
                </div>
                <div class="ssfp-text-field-input-1 csm-width-nsf">
                  {{ formData.authorizedPersonName }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="formData.certificateCollectionOption === 'representative'"
            class="ssfp-single-row"
          >
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-small">
                  NRIC No.<br>身份证号码
                </div>
                <div class="ssfp-text-field-input-1 csm-width-nsf">
                  {{ formData.authorizedPersonNric }}
                </div>
              </div>
            </b-col>
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-small">
                  Contact No.<br>联络号码
                </div>
                <div class="ssfp-text-field-input-1 csm-width-nsf">
                  {{ formData.authorizedPersonContact }}
                </div>
              </div>
            </b-col>
          </b-row> -->
        </b-col>
      </b-row>
    </div>
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <div class="page-break-after"></div>
    <div class="formWrapper filled">
      <b-row>
        <b-col cols="12">
          <div class="form-header floatCss">
            <b-row>
              <b-col cols="12">
                <div class="form-header-inner d-flex justify-content-between">
                  <div class="d-flex">
                    <div class="dForm-top-logo">
                      <img :src="logoSrc">
                    </div>
                    <div class="dForm-companyDetails">
                      <div class="dForm-cmBlock">
                        <h2>
                          <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                        </h2>
                      </div>
                      <div class="dForm-cmBlock2">
                        <p>(Co. Reg. No. 200401183W)</p>
                        <p>(GST Group Reg. No. M90364395L)</p>
                      </div>
                    </div>
                  </div>
                  <div class="dForm-top-right d-flex">
                    <h5 class="text-block font-small-12">
                      NV-SG-CSD-FS03 REV: 2
                    </h5>
                    <h5>File No: {{ formData.fileNo || '-' }}</h5>
                    <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="pp-section-tittle">
                  <h2>Sales order - niche 骨灰灵位认购同意书</h2>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row class="ssfp-form-wrapper">
        <b-col cols="12">
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-section-tittle2">
                <h2>PARTICULARS of Sales and Service Agent  销售代理及服务代理资料</h2>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-pl-single-row">
            <b-col
              cols="8"
              md="8"
              lg="8"
            >
              <div class="ssfp-pl-block floatCss">
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Agency 区代理
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    {{ formData.salesAgentAgency }}
                  </div>
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Sales Agent 销售代理
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    {{ formData.salesAgentName }}
                  </div>
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Agency 区代理
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    {{ formData.serviceAgentAgency }}
                  </div>
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Service Agent 服务代理
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    {{ formData.serviceAgentName }}
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-section-tittle2">
                <h2>Personal Data Consent 个人资料使用同意书</h2>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-ssfp-check-info nsf-cm-1 active floatCss">
                I further declare that the Company has made available to me, the Company’s Customer Privacy Policy Statement ("Statement") as required under the Personal Data Protection Act (Act 26 of 2012), and having read and inspected the same, hereby agree that I consent to the Company processing my personal data, and confirm that I have authority to provide the personal data of any third parties for processing by the Company in accordance with the Notice.
              </div>
            </b-col>
          </b-row>
          <template v-if="formData.showPurchaseDeclaration">
            <b-row>
              <b-col
                cols="12"
                class="custom-gap-10"
              >
                <div class="pp-section-tittle2">
                  <h2>purchase DECLARATION 购买声明</h2>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                class="custom-gap-10"
              >
                <div class="pp-ssfp-check-info active floatCss">
                  <p>I have on this date purchased the Niches <strong>{{ formData.purchasedLotsText }}</strong> from Mount Prajna Ltd and I declared and acknowledge that the purchase was:-</p>
                  <ol>
                    <li>Voluntarily concluded;</li>
                    <li>Made with full understanding of the product;</li>
                    <li>Made with awareness and understanding that speculation of the said product(s) is discouraged and that I will not hold the Company responsible in any way on the re-sale of the same in the secondary market.</li>
                  </ol>
                </div>
              </b-col>
            </b-row>
          </template>
          <template v-if="formData.isAgentPurchase">
            <b-row>
              <b-col cols="12">
                <div class="pp-section-tittle2">
                  <h2>agent self purchase DECLARATION 代理人自购声明</h2>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                class="custom-gap-10"
              >
                <div class="nsf-custom-tittle1 floatCss">
                  <h4>Cooling-Off Period</h4>
                  <p>Where the Service Advisor is a purchaser of any product, the "Cooling-Off" period shall be sixty (60) days.</p>
                  <h4>Refund During Cooling-Off Period</h4>
                  <ol>
                    <li>
                      Refund request must be submitted within the "Cooling-Off" period by completing the relevant Form(s) as follow:
                      <ol>
                        <li>
                          <h5>For cancellation and refund</h5>
                          <p>Complete Form II and submit the signed Form II together with customer copy of Sales Order and all temporary receipt/official receipt.</p>
                        </li>
                        <li>
                          <h5>For cancellation and transfer payment to other file(s) under same purchaser</h5>
                          <p>Complete Form I and submit the signed Form I together with customer copy of Sales Order and all temporary receipt/official receipt.</p>
                        </li>
                      </ol>
                    </li>
                    <li>The refund shall be subject to such deduction (i.e. processing fee, terminal charges and etc) as may be appropriate.</li>
                    <li>Refund will be made to Purchaser within 30 days upon receipt of signed form with complete submission of all required documents.</li>
                  </ol>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                class="custom-gap-10"
              >
                <div class="pp-ssfp-check-info nsf-cm-1 active floatCss">
                  I acknowledge this is an agent purchase and the terms of the cooling-off period that applies to agent purchases.
                </div>
              </b-col>
            </b-row>
          </template>
          <template v-if="!(formData.showPurchaseDeclaration && formData.isAgentPurchase)">
            <b-row>
              <b-col
                cols="12"
                class="custom-gap-10"
              >
                <div class="pp-section-tittle2">
                  <h2>marketing consent 声明</h2>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="pp-section-tittle3 floatCss">
                  <p>From time to time, the Group may use personal data disclosed by you in this Form to send you advertising and promotional material. If you do not wish to receive such material, kindly check the box below.</p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                class="custom-gap-10"
              >
                <div
                  class="pp-ssfp-check-info floatCss"
                  :class="{ 'active': formData.marketingDataConsent == 'true' }"
                >
                  No, I would not like to receive advertising and promotional material from the Group.
                </div>
              </b-col>
            </b-row>
          </template>
        </b-col>
      </b-row>
      <b-row
        v-if="!(formData.showPurchaseDeclaration && formData.isAgentPurchase)"
        class="ssfp-signature"
      >
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <p>Purchaser 购买者签名</p>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div
                v-if="formData.signOne"
                class="pp-signature-block floatCss"
              >
                <img
                  :src="formData.signOne"
                  alt="signature"
                >
              </div>
              <div
                v-else
                id="signOne"
                class="pp-signature-block signature-block-yellow floatCss"
              >
                <span>Sign here</span>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <h4>Name 姓名: {{ formData.customerName }}</h4>
            <h4>Date 日期: {{ (formData.signOneDate ? dateFormatWithTime(formData.signOneDate) : '') }}</h4>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <div
      v-if="formData.showPurchaseDeclaration && formData.isAgentPurchase"
      class="page-break-after"
    ></div>
    <div
      v-if="formData.showPurchaseDeclaration && formData.isAgentPurchase"
      class="formWrapper filled"
    >
      <b-row>
        <b-col cols="12">
          <div class="form-header floatCss">
            <b-row>
              <b-col cols="12">
                <div class="form-header-inner d-flex justify-content-between">
                  <div class="d-flex">
                    <div class="dForm-top-logo">
                      <img :src="logoSrc">
                    </div>
                    <div class="dForm-companyDetails">
                      <div class="dForm-cmBlock">
                        <h2>
                          <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                        </h2>
                      </div>
                      <div class="dForm-cmBlock2">
                        <p>(Co. Reg. No. 200401183W)</p>
                        <p>(GST Group Reg. No. M90364395L)</p>
                      </div>
                    </div>
                  </div>
                  <div class="dForm-top-right d-flex">
                    <h5 class="text-block font-small-12">
                      NV-SG-CSD-FS03 REV: 2
                    </h5>
                    <h5>File No: {{ formData.fileNo || '-' }}</h5>
                    <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="pp-section-tittle">
                  <h2>Sales order - niche 骨灰灵位认购同意书</h2>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row class="ssfp-form-wrapper">
        <b-col cols="12">
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-section-tittle2">
                <h2>marketing consent 声明</h2>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="pp-section-tittle3 floatCss">
                <p>From time to time, the Group may use personal data disclosed by you in this Form to send you advertising and promotional material. If you do not wish to receive such material, kindly check the box below.</p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div
                class="pp-ssfp-check-info floatCss"
                :class="{ 'active': formData.marketingDataConsent == 'true' }"
              >
                No, I would not like to receive advertising and promotional material from the Group.
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="ssfp-signature">
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <p>Purchaser 购买者签名</p>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div class="pp-signature-block floatCss">
                <img
                  v-if="formData.signOne"
                  :src="formData.signOne"
                  alt="signature"
                >
                <span v-else />
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <h4>Name 姓名: {{ formData.customerName }}</h4>
            <h4>Date 日期: {{ (formData.signOneDate ? dateFormatWithTime(formData.signOneDate) : '') }}</h4>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <div class="page-break-after"></div>
    <div class="formWrapper filled">
      <b-row>
        <b-col cols="12">
          <div class="form-header floatCss">
            <b-row>
              <b-col cols="12">
                <div class="form-header-inner d-flex justify-content-between">
                  <div class="d-flex">
                    <div class="dForm-top-logo">
                      <img :src="logoSrc">
                    </div>
                    <div class="dForm-companyDetails">
                      <div class="dForm-cmBlock">
                        <h2>
                          <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                        </h2>
                      </div>
                      <div class="dForm-cmBlock2">
                        <p>(Co. Reg. No. 200401183W)</p>
                        <p>(GST Group Reg. No. M90364395L)</p>
                      </div>
                    </div>
                  </div>
                  <div class="dForm-top-right d-flex">
                    <h5 class="text-block font-small-12">
                      NV-SG-CSD-FS03 REV: 2
                    </h5>
                    <h5>File No: {{ formData.fileNo || '-' }}</h5>
                    <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="pp-section-tittle">
                  <h2>Sales order - niche 骨灰灵位认购同意书</h2>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="custom-gap-top-20"
        >
          <div class="pp-section-tittle2">
            <h2>TERMS & CONDITIONS</h2>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="custom-gap-top-20"
        >
          <div class="tc-single-wrapper floatCss">
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                1
              </div>
              <div class="tc-info-rt">
                <p>Mount Prajna herein Ltd. (hereinafter referred to as "the Vendor") is the developer of the columbarium known as "Nirvana".</p>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>TERM</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                2
              </div>
              <div class="tc-info-rt">
                <p>The licence granted herein shall commence from the date of occupation of the niche until 12 August 2098.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                3
              </div>
              <div class="tc-info-rt">
                <p>The licence hereby granted does not confer any proprietary interest to the Purchaser or his next-of-kin.</p>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>PAYMENT</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                4
              </div>
              <div class="tc-info-rt">
                <p>Subject to the full payment of the purchase price, the Purchaser shall be entitled to a licence to use the niche identified and described herein.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                5
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p>The balance of the purchase price shall be immediately due and payable upon the exercise of the licence and interment of the cinerary urn. Nothing in this Sales Order precludes the Vendor's right to recover any balance purchase price from the Purchaser where the licence has been exercised and interment of the cinerary urn has been duly completed.</p>
                  <ol>
                    <li>Service Charge of $500.00 (plus prevailing GST rate) for 2nd utilisation (this charge may be subjected to changes).</li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                6
              </div>
              <div class="tc-info-rt">
                <p>The balance of the purchase price shall be immediately due and payable upon the exercise of the licence and interment of the cinerary urn. Nothing in this Sales Order precludes the Vendor's right to recover any balance purchase price from the Purchaser where the licence has been exercised and interment of the cinerary urn has been duly completed.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                7
              </div>
              <div class="tc-info-rt">
                <p>All payments made by cheque or bank draft should be made payable to the Vendor. Confirmation of purchase is subject to clearing of the cheque or bank draft. Please write the File No. and the name of the payee on the reverse side of the cheque.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                8
              </div>
              <div class="tc-info-rt">
                <p>Service Advisors are NOT authorised to accept cash payments. Payment in cash, NETS and credit card must be made directly at the sales counter where the Purchaser will be issued with a receipt from the Vendor after the payment is processed. Only authorised staffs at the sales counter are allowed to collect cash on behalf of the Vendor from the Purchaser. Service Advisors are not allowed to issue personal receipts on behalf of the Vendor.</p>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>TRANSFER</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                9
              </div>
              <div class="tc-info-rt">
                <p>The Purchaser is at liberty at any time to transfer his rights to the niche by furnishing the certificate of purchase and paying a transfer fee of 2% of the prevailing sale price or $100.00 (plus prevailing GST rate), whichever is higher. No transfer in any manner whatsoever will be permitted after the licence herein has been exercised by the interment of the cinerary urn.</p>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>GENERAL</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                10
              </div>
              <div class="tc-info-rt">
                <p>A photocopy of the front of the Purchaser's NRIC is to be provided with this Sales Order.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                11
              </div>
              <div class="tc-info-rt">
                <p>Only a Sales Order accepted by the Vendor is valid and binding on the Vendor. Upon acceptance by the Vendor, a Certificate will be issued within 45 days upon full payment of the purchase price.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                12
              </div>
              <div class="tc-info-rt">
                <p>If any transaction is not finalised within 10 days of the deposit being paid, the said transaction will be terminated, and the deposit will be refunded, less 10% for processing fees.</p>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <div class="page-break-after"></div>
    <div class="formWrapper filled">
      <b-row>
        <b-col cols="12">
          <div class="form-header floatCss">
            <b-row>
              <b-col cols="12">
                <div class="form-header-inner d-flex justify-content-between">
                  <div class="d-flex">
                    <div class="dForm-top-logo">
                      <img :src="logoSrc">
                    </div>
                    <div class="dForm-companyDetails">
                      <div class="dForm-cmBlock">
                        <h2>
                          <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                        </h2>
                      </div>
                      <div class="dForm-cmBlock2">
                        <p>(Co. Reg. No. 200401183W)</p>
                        <p>(GST Group Reg. No. M90364395L)</p>
                      </div>
                    </div>
                  </div>
                  <div class="dForm-top-right d-flex">
                    <h5 class="text-block font-small-12">
                      NV-SG-CSD-FS03 REV: 2
                    </h5>
                    <h5>File No: {{ formData.fileNo || '-' }}</h5>
                    <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="pp-section-tittle">
                  <h2>Sales order - niche 骨灰灵位认购同意书</h2>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="custom-gap-top-20"
        >
          <div class="tc-single-wrapper floatCss">
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                13
              </div>
              <div class="tc-info-rt">
                <p>Once a transaction is finalised, there shall be no refund of the purchase price. In no event shall the Vendor be liable for any claim of any kind, for any loss, or for any damage arising out of, in connection with, or resulting from this Sales Order in excess of the net price of the product in question (i.e. purchase price less any applicable fees/charges). Any claim relating to or arising out of this Sales Order must be made within one year from the date of purchase.</p>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>GENERAL</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                14
              </div>
              <div class="tc-info-rt">
                <p>The Vendor may, from time to time, make rules and regulations governing the use and maintenance of the columbarium and may at any time or times, amend, alter, change or modify the terms and conditions of this Sales Order with respect to the use, operation and maintenance of the columbarium and of the niches/pedestal therein. All terms and conditions hereof, or amendments, alterations, changes or modifications thereof, and all rules and regulations made pursuant thereto, shall apply to and be binding upon the Purchaser.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                15
              </div>
              <div class="tc-info-rt">
                <p>All notices are required to be given in writing. Any notice to the Purchaser shall be sufficiently served if sent by prepaid post addressed to the Purchaser at the Purchaser's address herein stated or to the Purchaser's last known address. It is the Purchaser's duty to inform the Vendor of any change of address.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                16
              </div>
              <div class="tc-info-rt">
                <p>A copy of these Terms & Conditions in the Chinese language is available upon request. In the event of any inconsistency in the terms herein and those in the Chinese version, the terms and conditions in English language shall prevail</p>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>TERMINATION</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                17
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p> The licence may be terminated automatically whereupon the Vendor shall have the liberty to dispose of or deal with the niche in such manner as the Vendor shall in its sole discretion think fit without having to account to the Purchaser in any manner whatsoever and without having to make a refund to the Purchaser of any monies already paid, following the occurrence of any of the following events:-</p>
                  <ol>
                    <li>When the Purchaser gives the Vendor notice of termination of the licence or notice of his intention to open the niche and remove the cinerary urn deposited therein; and/or</li>
                    <li>When the Purchaser himself removes the cinerary urn; and/or</li>
                    <li>When the purchase price for the niche herein is paid under an instalment scheme, if the Purchaser defaults in the payment of any instalment for more than 30 days.</li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>USAGE</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                18
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p>The Purchaser SHALL:-</p>
                  <ol>
                    <li>With his invitees, observe proper decorum and the code of conduct, which is reviewable from time to time, at all times on the premises; and</li>
                    <li>With his invitees, have free and unhindered access to the niche and the car park area and other areas in common with other licensees and all persons having the same or similar rights; and</li>
                    <li>Inform the Vendor at least 24-hours before any installation; and</li>
                    <li>Use the niche solely for the deposit of one cinerary urn unless specified otherwise.</li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                19
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p>The Purchaser SHALL NOT:-</p>
                  <ol>
                    <li>Use the niche save for the purpose for which it is intended; and</li>
                    <li>Deposit any, noxious or offensive materials in the niche or on the premises; and</li>
                    <li>Cause any damage to the external facade of the niche, columbarium or any part thereof, and on the premises; and</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <div class="page-break-after"></div>
    <div class="formWrapper filled">
      <b-row>
        <b-col cols="12">
          <div class="form-header floatCss">
            <b-row>
              <b-col cols="12">
                <div class="form-header-inner d-flex justify-content-between">
                  <div class="d-flex">
                    <div class="dForm-top-logo">
                      <img :src="logoSrc">
                    </div>
                    <div class="dForm-companyDetails">
                      <div class="dForm-cmBlock">
                        <h2>
                          <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                        </h2>
                      </div>
                      <div class="dForm-cmBlock2">
                        <p>(Co. Reg. No. 200401183W)</p>
                        <p>(GST Group Reg. No. M90364395L)</p>
                      </div>
                    </div>
                  </div>
                  <div class="dForm-top-right d-flex">
                    <h5 class="text-block font-small-12">
                      NV-SG-CSD-FS03 REV: 2
                    </h5>
                    <h5>File No: {{ formData.fileNo || '' }}</h5>
                    <h5>Sales Order No: {{ formData.orderNo || '' }}</h5>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="pp-section-tittle">
                  <h2>Sales order - niche 骨灰灵位认购同意书</h2>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="custom-gap-top-20"
        >
          <div class="tc-single-wrapper floatCss">
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number tc-single-number2">
                (d)
              </div>
              <div class="tc-info-rt tc-info-rt2">
                <p>Along with his invitees, smoke or litter on the premises; and</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number tc-single-number2">
                (e)
              </div>
              <div class="tc-info-rt tc-info-rt2">
                <p>Open or tamper with the niche without prior consent from the Vendor.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                20
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p>The purchase of the niche is purely for the Purchaser's or nominated intended user's use and not for investment or for speculative purposes.</p>
                  <ol>
                    <li>The Purchaser intends that the niche shall be used by the intended user named in this Sales Order. Where no person has been nominated, the Purchaser shall be deemed to be the intended user of the niche.</li>
                    <li>Until the interment of a cinerary urn into the niche, the Purchaser may by notice in writing to the Vendor nominate such person from time to time to be the beneficiary of the niche.</li>
                    <li>f the niche is not ready for use at the date of this contract; the Certificate shall expressly state so and the date of completion of the niche shall be prominently stamped on the Certificate. The Purchaser shall not be entitled to annul the purchase herein under any circumstances.</li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>LIMITING LIABILITY</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                21
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p>The Vendor shall not be liable to the Purchaser in any manner whatsoever resulting from or arising out of any loss or damage to any material chattels or things deposited in the niche.</p>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="ssfp-signature">
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <p>Purchaser 购买者签名</p>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <!-- <div class="pp-signature-block floatCss">
                <img
                  v-if="formData.signTwo"
                  :src="formData.signTwo"
                  alt="signature"
                >
                <span v-else />
              </div> -->
              <div
                v-if="formData.signTwo"
                class="pp-signature-block floatCss"
              >
                <img
                  :src="formData.signTwo"
                  alt="signature"
                >
              </div>
              <div
                v-else
                id="signTwo"
                class="pp-signature-block signature-block-yellow floatCss"
              >
                <span>Sign here</span>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <h4>Name 姓名: {{ formData.customerName }}</h4>
            <h4>Date 日期: {{ (formData.signTwoDate ? dateFormatWithTime(formData.signTwoDate) : '') }}</h4>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

import moment from 'moment'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/nr-logo.png'),
      formData: JSON.parse(localStorage.getItem('installmentFormData')) || {},
    }
  },

  methods: {
    getSignOne() {
      console.log('getSignOne')
    },
    getSignTwo() {
      console.log('getSignTwo')
    },
    formatDate(date) {
      if (!date) return '-'
      const timezone = process.env.VUE_APP_TIME_ZONE
      return moment(date).utcOffset(timezone).format('DD/MM/YYYY')
    },
    // formData.rebate was never set by the backend (promotions/discounts are real arrays, not a
    // single flat field) - this row silently never rendered regardless of a real promotion being
    // applied, so a signed Sales Order could carry a discounted GST/Total with no line item
    // explaining why. Sums both promotions[].amount and discounts[].amount actually applied to
    // this item, reusing the same "Rebate" row rather than adding a new one.
    totalDiscount() {
      const promotions = (this.formData.promotions || []).reduce((sum, p) => sum + (Number(p.amount) || 0), 0)
      const discounts = (this.formData.discounts || []).reduce((sum, d) => sum + (Number(d.amount) || 0), 0)
      return promotions + discounts
    },
  },
}
</script>

<style>
@media print {
  .page-break-after {
    display: block;
    /* ensure block context */
    page-break-before: always;
    /* legacy */
    break-before: page;
  }

  .formWrapper,
  .niche-wr,
  .ssfp-form-wrapper,
  .ssfp-signature {
    page-break-inside: avoid;
    /* legacy */
    break-inside: avoid;
    /* modern */
  }
}
</style>
